import { Text, Tooltip } from '@lego/klik-ui';

type Props = {
  text: string;
};

export const TruncatedTextTooltip = ({ text }: Props) => (
  <Tooltip label={text} placement="bottom-start">
    <Text
      color="gray.600"
      cursor="pointer"
      display="block"
      fontSize="sm"
      overflow="hidden"
      textOverflow="ellipsis"
      whiteSpace="nowrap"
    >
      {text}
    </Text>
  </Tooltip>
);
